var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85 4.30039C2.85 4.00039 2.7 3.70039 2.55 3.55039L0.3 0.850389V0.400391H7.2L12.6 12.2504L17.4 0.400391H24V0.850389L22.05 2.65039C21.9 2.80039 21.75 2.95039 21.9 3.25039V16.7504C21.9 16.9004 21.9 17.2004 22.05 17.3504L23.85 19.1504V19.6004H14.4V19.1504L16.35 17.2004C16.5 17.0504 16.5 16.9004 16.5 16.6004V5.65039L11.1 19.3004H10.5L4.2 5.65039V14.8004C4.2 15.2504 4.35 15.5504 4.5 15.8504L7.05 18.8504V19.3004H0V18.8504L2.55 15.8504C2.85 15.5504 3 15.2504 2.85 14.8004V4.30039Z",
    fill: "var(--color-neutral-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.60052c9020970d8d2e2469660f1cbae0.svg";
export { ForwardRef as ReactComponent };